<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="datetime" label="发布时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="input" label="用户昵称" name="nick_name"></c-form-item>
<!--                    <c-form-item type="select" label="是否推荐" name="is_recommend" :options="recommendState"></c-form-item>-->
                    <c-form-item type="checkbox" name="moments_type" :options="momentsType"></c-form-item>
                    <c-form-item type="checkbox" name="state" :value="[1]" :options="state"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_moments_apply_edit" color="black" hollow @click="updateDelete()">批量删除</c-button>
            </m-operate>

            <c-table ref="table">

                <c-table-column
                        type="selector"
                ></c-table-column>

                <c-table-column
                        label="审核状态"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 1" style="color:dodgerblue">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 2" style="color:darkgreen">{{stateText[data.state]}}</span>
                    </template>
                </c-table-column>

              <c-table-column
                  label="发布用户"
                  name="head_photo"
                  width="200"
              >
                <template v-slot="{data}">
                  <div class="flex-center-cross">
                    <c-image :src="data.head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                    <div>
                      <span>{{data.nick_name||'--'}}</span></br>
                      <span style="color:blue">{{data.user_manage_mobilephone}}</span>
                    </div>
                  </div>
                </template>
              </c-table-column>

                <c-table-column
                        label="社区类型"
                        name="moments_type"
                        width="70"
                >
                    <template v-slot="{data}">
                        <span v-if="data.moments_type == 3" >话题</span>
                        <span v-if="data.moments_type == 5" >分享</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="社区标题"
                        name="moments_title"
                        width="150"
                ></c-table-column>


                <c-table-column
                        label="社区内容"
                        name="content"
                        width="200"
                >
                    <template v-slot="{data}">
                        <span class="ellipsis-2" :title="data.content">{{data.content}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="显示隐藏"
                        name="is_valid"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.is_valid == 1" style="color:green">显示</span>
                        <span v-else style="color:red">隐藏</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="发布时间"
                        name="create_date"
                        width="140"
                >
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="200"
                >
                    <template v-slot="row">
                        <c-table-button power="b_moments_apply_view"  @click="navigateTo(`/moments_apply_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button power="b_moments_apply_apply" v-if="row.data.state == 1" @click="navigateTo(`/moments_apply_verify/${row.data.id}`)">审核</c-table-button>
                        <c-table-button power="b_moments_apply_edit" @click="updateDelete(row.data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

    </page>
</template>

<script>
    export default {
        name: 'm_moments_apply',

        data() {
            return {
                momentsType: [
                    {name: '话题',value: 3},
                    {name: '分享',value: 5}
                ],
                state: [
                    {name: '待审核',value: 1},
                    {name: '审核通过',value: 2}
                ],
                recommendState: [{
                    name: '不推荐',
                    value: '0'
                }, {
                    name: '推荐',
                    value: '1'
                }
                ]
            }
        },

        computed: {
            stateText() {
                var state = {};
                this.state.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        mounted() {
            this.$refs.search.search();
            this.$bus.$on('momentsApplyList.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/moments_apply/list',
                    data
                });
            },
            updateDelete(item) {
                var list = item ? [{
                    data: item
                }] : this.$refs.table.getRow('selected');
                if (!list.length) {
                    this.$message({
                        text: '请选择要操作的内容'
                    });
                    return;
                }

                this.$confirm({
                    text: '确定要删除'+ (item ? '该' : '所选') +'内容吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/moments/batch_delete',
                            data: {
                                ids: Array.from(list, item => item.data.id),
                                is_delete:1
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },



        }
    }
</script>